import styled from 'styled-components';

import { Section, InnerSection } from '../../../../styles/section/section';

export const StyledSection = styled(Section)`
  padding-top: 2rem;
`;

export const StyledSectionInner = styled(InnerSection)`
  padding-top: 0;
`;